(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tw-advanced-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-advanced-price')) {
    customElements.define('tw-advanced-price', class extends HTMLElement {
      connectedCallback() {
        this._section = this.closest('.shopify-section, dialog');
        this._onProductSelect = this._handleProductSelect.bind(this);
        this._section?.addEventListener('shopify:product:select', this._onProductSelect);
      }
      disconnectedCallback() {
        this._section?.removeEventListener('shopify:product:select', this._onProductSelect);
      }
      _handleProductSelect(event) {
        event.promise?.then(({ detail }) => {
          if (!detail?.html) return;
          const next = detail.html.querySelector(`tw-advanced-price[data-block-id="${this.dataset.blockId}"]`);
          if (!next) return;
          if (detail.newProduct?.id) this.dataset.productId = detail.newProduct.id;
          this.innerHTML = next.innerHTML;
        }).catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[tw-advanced-price] update failed', error);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tw-bundle-save"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-bundle-save')) {
    customElements.define('tw-bundle-save', class extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;

        this._connected = true;
        this._section = this.closest('.shopify-section, dialog');
        this._boundForm = null;

        this._onChange = this._handleChange.bind(this);
        this._onProductSelect = this._handleProductSelect.bind(this);
        this._onSubmitCapture = this._handleSubmitCapture.bind(this);

        this.addEventListener('change', this._onChange);
        this._section?.addEventListener('shopify:product:select', this._onProductSelect);

        queueMicrotask(() => this._applySelected());
        requestAnimationFrame(() => this._applySelected());
      }

      disconnectedCallback() {
        this.removeEventListener('change', this._onChange);
        this._section?.removeEventListener('shopify:product:select', this._onProductSelect);
        this._unbindForm();
        this._connected = false;
      }

      _handleChange(event) {
        const input = event.target.closest('input[data-quantity]');
        if (!input) return;

        this._setQuantity(Number(input.dataset.quantity || input.value || 1));
      }

      _applySelected() {
        const selected = this.querySelector('input[data-quantity]:checked');
        if (!selected) return;

        this._setQuantity(Number(selected.dataset.quantity || selected.value || 1));
      }

      _scope() {
        return this.closest('[data-testid="product-information"], .product-information') || this._section || document;
      }

      _resolveProductForm() {
        const details = this.closest('.product-details');
        const scope = details || this._scope();

        const productForms = Array.from(scope.querySelectorAll('product-form-component'));

        return (
          productForms.find((component) => {
            const sameProduct =
              !this.dataset.productId ||
              !component.dataset.productId ||
              component.dataset.productId === this.dataset.productId;

            return sameProduct && component.querySelector('form[data-type="add-to-cart-form"]');
          }) ||
          productForms.find((component) => component.querySelector('form[data-type="add-to-cart-form"]')) ||
          null
        );
      }

      _bindForm(form) {
        if (this._boundForm === form) return;

        this._unbindForm();
        this._boundForm = form;
        this._boundForm?.addEventListener('submit', this._onSubmitCapture, true);
      }

      _unbindForm() {
        this._boundForm?.removeEventListener('submit', this._onSubmitCapture, true);
        this._boundForm = null;
      }

      _selectedQuantity() {
        const selected = this.querySelector('input[data-quantity]:checked');
        const quantity = Number(selected?.dataset.quantity || selected?.value || 1);

        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

      _normalizeQuantity(input, quantity) {
        const min = Number(input?.min || input?.dataset.min || 1);
        const max = input?.max ? Number(input.max) : null;
        const step = Number(input?.step || 1);

        let next = Math.max(Number.isFinite(min) ? min : 1, quantity);

        if (max !== null && Number.isFinite(max)) {
          next = Math.min(next, max);
        }

        if (Number.isFinite(step) && step > 1) {
          const base = Number.isFinite(min) ? min : 1;
          next = base + Math.round((next - base) / step) * step;
        }

        return next;
      }

      _writeQuantity(productForm, quantity) {
        if (!productForm) return;

        const form = productForm.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) return;

        this._bindForm(form);

        let input = form.querySelector('input[name="quantity"]');

        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.appendChild(input);
        }

        const next = this._normalizeQuantity(input, quantity);
        const component = input.closest('quantity-selector-component');

        input.value = String(next);
        productForm.dataset.quantityDefault = String(next);

        if (component && typeof component.setValue === 'function') {
          component.setValue(String(next));
          component.updateButtonStates?.();
        }

        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      _setQuantity(quantity) {
        if (!Number.isFinite(quantity) || quantity < 1) {
          quantity = 1;
        }

        const productForm = this._resolveProductForm();
        if (!productForm) return;

        this._writeQuantity(productForm, quantity);
      }

      _handleSubmitCapture() {
        const productForm = this._resolveProductForm();
        if (!productForm) return;

        this._writeQuantity(productForm, this._selectedQuantity());
      }

      _handleProductSelect(event) {
        event.promise
          ?.then(({ detail }) => {
            if (!detail?.html) return;

            const next = detail.html.querySelector(
              `tw-bundle-save[data-block-id="${this.dataset.blockId}"]`
            );

            if (!next) return;

            if (detail.newProduct?.id) {
              this.dataset.productId = detail.newProduct.id;
            }

            this.innerHTML = next.innerHTML;

            queueMicrotask(() => this._applySelected());
            requestAnimationFrame(() => this._applySelected());
          })
          .catch((error) => {
            if (error?.name !== 'AbortError') {
              console.warn('[tw-bundle-save] update failed', error);
            }
          });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tw-final-cta"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-final-cta')) {
    customElements.define(
      'tw-final-cta',
      class extends HTMLElement {
        connectedCallback() {
          this._button = this.querySelector('[data-tw-final-cta-button]');
          this._onClick = this._handleClick.bind(this);
          this._button?.addEventListener('click', this._onClick);
        }

        disconnectedCallback() {
          this._button?.removeEventListener('click', this._onClick);
        }

        _scope() {
          return this.closest('[data-testid="product-information"], .product-information') ||
            this.closest('.shopify-section') ||
            document;
        }

        _nativeButton() {
          const scope = this._scope();

          return scope.querySelector('product-form-component button[type="submit"]') ||
            scope.querySelector('product-form-component [name="add"]') ||
            scope.querySelector('.product-form-buttons button[type="submit"]');
        }

        _handleClick() {
          const nativeButton = this._nativeButton();
          if (!nativeButton) return;

          if (this.dataset.action === 'add') {
            nativeButton.click();
          } else {
            nativeButton.scrollIntoView({ behavior: 'smooth', block: 'center' });

            try {
              nativeButton.focus({ preventScroll: true });
            } catch (_) {
              nativeButton.focus();
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tw-inventory-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-inventory-status')) {
    customElements.define(
      'tw-inventory-status',
      class extends HTMLElement {
        connectedCallback() {
          this._section = this.closest('.shopify-section, dialog');
          this._onProductSelect = this._handleProductSelect.bind(this);
          this._section?.addEventListener('shopify:product:select', this._onProductSelect);
        }

        disconnectedCallback() {
          this._section?.removeEventListener('shopify:product:select', this._onProductSelect);
        }

        _handleProductSelect(event) {
          event.promise
            ?.then(({ detail }) => {
              if (!detail?.html) return;

              const next = detail.html.querySelector(
                `tw-inventory-status[data-block-id="${this.dataset.blockId}"]`
              );

              if (!next) return;

              if (detail.newProduct?.id) {
                this.dataset.productId = detail.newProduct.id;
              }

              this.innerHTML = next.innerHTML;
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') {
                console.warn('[tw-inventory-status] update failed', error);
              }
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tw-quantity-break"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-quantity-break')) {
    customElements.define(
      'tw-quantity-break',
      class extends HTMLElement {
        connectedCallback() {
          if (this._connected) return;

          this._connected = true;
          this._section = this.closest('.shopify-section, dialog');
          this._onChange = this._handleChange.bind(this);
          this._onProductSelect = this._handleProductSelect.bind(this);

          this.addEventListener('change', this._onChange);
          this._section?.addEventListener('shopify:product:select', this._onProductSelect);

          queueMicrotask(() => this._applySelected());
        }

        disconnectedCallback() {
          this.removeEventListener('change', this._onChange);
          this._section?.removeEventListener('shopify:product:select', this._onProductSelect);
          this._connected = false;
        }

        _scope() {
          return this.closest('[data-testid="product-information"], .product-information') || this._section || document;
        }

        _handleChange(event) {
          const input = event.target.closest('input[data-quantity]');
          if (!input) return;
          this._setQuantity(Number(input.dataset.quantity || 1));
        }

        _applySelected() {
          const input = this.querySelector('input[data-quantity]:checked');
          if (input) {
            this._setQuantity(Number(input.dataset.quantity || 1));
          }
        }

        _setQuantity(quantity) {
          if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

          const scope = this._scope();
          const component = scope.querySelector('quantity-selector-component');
          const input =
            component?.querySelector('input[name="quantity"]') ||
            scope.querySelector('product-form-component input[name="quantity"]');

          if (!input) return;

          const min = Number(input.min || input.dataset.min || 1);
          const max = input.max ? Number(input.max) : null;
          const step = Number(input.step || 1);

          let next = Math.max(min, quantity);

          if (max !== null && Number.isFinite(max)) {
            next = Math.min(next, max);
          }

          if (step > 1) {
            next = min + Math.round((next - min) / step) * step;
          }

          if (component && typeof component.setValue === 'function') {
            component.setValue(String(next));
            component.onQuantityChange?.();
            component.updateButtonStates?.();
          } else {
            input.value = String(next);
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        _handleProductSelect(event) {
          event.promise
            ?.then(({ detail }) => {
              if (!detail?.html) return;

              const next = detail.html.querySelector(
                `tw-quantity-break[data-block-id="${this.dataset.blockId}"]`
              );

              if (!next) return;

              if (detail.newProduct?.id) {
                this.dataset.productId = detail.newProduct.id;
              }

              this.innerHTML = next.innerHTML;
              queueMicrotask(() => this._applySelected());
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') {
                console.warn('[tw-quantity-break] update failed', error);
              }
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tw-sale-savings"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-sale-savings')) {
    customElements.define(
      'tw-sale-savings',
      class extends HTMLElement {
        connectedCallback() {
          this._section = this.closest('.shopify-section, dialog');
          this._onProductSelect = this._handleProductSelect.bind(this);
          this._section?.addEventListener('shopify:product:select', this._onProductSelect);
        }

        disconnectedCallback() {
          this._section?.removeEventListener('shopify:product:select', this._onProductSelect);
        }

        _handleProductSelect(event) {
          event.promise
            ?.then(({ detail }) => {
              if (!detail?.html) return;

              const next = detail.html.querySelector(
                `tw-sale-savings[data-block-id="${this.dataset.blockId}"]`
              );

              if (!next) return;

              if (detail.newProduct?.id) {
                this.dataset.productId = detail.newProduct.id;
              }

              this.innerHTML = next.innerHTML;
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') {
                console.warn('[tw-sale-savings] update failed', error);
              }
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tw-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tw-sticky-add-to-cart')) {
    customElements.define(
      'tw-sticky-add-to-cart',
      class extends HTMLElement {
        connectedCallback() {
          this._section = this.closest('.shopify-section, dialog');
          this._button = this.querySelector('[data-tw-sticky-atc-button]');
          this._onClick = this._handleClick.bind(this);
          this._onProductSelect = this._handleProductSelect.bind(this);

          this._button?.addEventListener('click', this._onClick);
          this._section?.addEventListener('shopify:product:select', this._onProductSelect);

          queueMicrotask(() => this._watchNativeButton());
        }

        disconnectedCallback() {
          this._button?.removeEventListener('click', this._onClick);
          this._section?.removeEventListener('shopify:product:select', this._onProductSelect);
          this._observer?.disconnect();
        }

        _scope() {
          return this.closest('[data-testid="product-information"], .product-information') ||
            this._section ||
            document;
        }

        _nativeButton() {
          const scope = this._scope();

          return scope.querySelector('product-form-component button[type="submit"]') ||
            scope.querySelector('product-form-component [name="add"]') ||
            scope.querySelector('.product-form-buttons button[type="submit"]');
        }

        _watchNativeButton() {
          const nativeButton = this._nativeButton();
          if (!nativeButton) return;

          this._observer?.disconnect();

          this._observer = new IntersectionObserver(
            ([entry]) => {
              this.classList.toggle('is-visible', !entry.isIntersecting);
            },
            { threshold: 0.15 }
          );

          this._observer.observe(nativeButton);
        }

        _handleClick() {
          const nativeButton = this._nativeButton();
          if (!nativeButton || nativeButton.disabled) return;
          nativeButton.click();
        }

        _handleProductSelect(event) {
          event.promise
            ?.then(({ detail }) => {
              if (!detail?.html) return;

              const next = detail.html.querySelector(
                `tw-sticky-add-to-cart[data-block-id="${this.dataset.blockId}"]`
              );

              if (!next) return;

              if (detail.newProduct?.id) {
                this.dataset.productId = detail.newProduct.id;
              }

              this.innerHTML = next.innerHTML;
              this._button = this.querySelector('[data-tw-sticky-atc-button]');
              this._button?.addEventListener('click', this._onClick);
              queueMicrotask(() => this._watchNativeButton());
            })
            .catch((error) => {
              if (error?.name !== 'AbortError') {
                console.warn('[tw-sticky-add-to-cart] update failed', error);
              }
            });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
